"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_CATEGORY_KEY = 'base';
exports.ICON_COMPONENT_KEY = 'icon';